import { render, staticRenderFns } from "./TabMarketing.vue?vue&type=template&id=5c5f2f48&scoped=true&"
import script from "./TabMarketing.vue?vue&type=script&lang=js&"
export * from "./TabMarketing.vue?vue&type=script&lang=js&"
import style0 from "./TabMarketing.vue?vue&type=style&index=0&id=5c5f2f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f2f48",
  null
  
)

export default component.exports